/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { createContext, styled, use } from 'fierry/react';

import Text from 'solis/react/primitive/text';


const WidthContext = createContext();


const Container = styled(Text)`
  display: inline-grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  gap: 6px;
  font-variant-numeric: tabular-nums;
`;


const Arrow = styled(Text)`
  grid-row: 1;
  grid-column: 2;
`;


const Cell = styled(Text)`
  grid-row: 1;
  grid-column: ${props => props.$column};
  min-width: ${props => props.$width};

  text-align: right;
`;


const Slot = ({ column, children, ...props }) =>
{
  const width = use(WidthContext);

  return <Cell $column = {column} $width = {width} {...props}>{children}</Cell>;
};


const NumberArrow = ({ size, width = '3ch', children }) =>
(
  <WidthContext value = {width}>
    <Container size = {size}>

      {children}
      <Arrow color = 'gray'>→</Arrow>

    </Container>
  </WidthContext>
);


NumberArrow.Left = (props) =>
{
  return <Slot column = {1} {...props} />;
};


NumberArrow.Right = (props) =>
{
  return <Slot column = {3} {...props} />;
};


export default NumberArrow;
